var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGcPproject2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24px/GCP project@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24px/GCP-project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79750652,13.9405335 L11.0149639,17.0238904 L9.44670823,19.7809728 L6.04059769,20.1305469 L3.82314031,17.04719 L5.39139598,14.2901076 L8.79750652,13.9405335 Z M17.9594023,8.88580006 L20.1768597,11.969157 L18.608604,14.7262394 L15.2024935,15.0758135 L12.9850361,11.9924566 L14.5532918,9.23537419 L17.9594023,8.88580006 Z M8.79750652,3.86945307 L11.0149639,6.95280997 L9.44670823,9.70989236 L6.04059769,10.0594665 L3.82314031,6.97610958 L5.39139598,4.21902719 L8.79750652,3.86945307 Z",
    id: "Polygon-2",
    stroke: "#545B71",
    strokeWidth: 1.65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcPproject2X);
export default __webpack_public_path__ + "static/media/GCP project@2x.bbe19e72e4ced13f4fd1f1c344cc8e09.svg";
export { ForwardRef as ReactComponent };